import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ObtenerConsolidadoParametrizacionMS, ParametrizacionService } from 'src/app/open-api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-password-verify',
  templateUrl: './app-password-verify.component.html',
  styleUrls: ['./app-password-verify.component.scss']
})
export class AppPasswordVerifyComponent implements OnInit {
  @Output() passwordValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancel: EventEmitter<string> = new EventEmitter<string>();

  consolidado?: ObtenerConsolidadoParametrizacionMS;
  formPassword: FormGroup;
  seePass = false;

  constructor(private fb: FormBuilder,) { 
    this.formPassword = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  ngOnInit(): void {
  }


  EmittPasswordValue(): void {
    this.passwordValue.emit(this.GetPasswordValue()?.value);
    this.GetPasswordValue()?.setValue('');
    this.GetPasswordValue()?.updateValueAndValidity();
  }

  GetPasswordValue(): AbstractControl | null {
    return this.formPassword.get('password');
  }


  EmittCancel(): void {

    Swal.fire({
      title: "Cancelar Verificación",
      text: "¿Está seguro que desea cancelar la verificación?",
      confirmButtonText: "Aceptar",
      cancelButtonText:"Cancelar",
      confirmButtonColor: "#3b7851",
      showCancelButton:true,
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        this.ngOnInit();
        this.cancel.emit('Cancelar');
      }
    });
    
  }




}
